module.exports = __webpack_public_path__ + "img/careers-recruiting-process-2.png?08b8a631c7c2baa3b2c46fa31405cd69";